import { Form, Spin } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../contractBooking/contractbooking.config";
import FeedbackModal from "../../../treasury/bond/components/FeedbackModal";
import StepsCard from "../../component/StepsCard";
import StepsComponent from "../../component/StepsComponent";
import SuccessModal from "../../component/SuccessModal";
import { useSearchCustomer } from "../../hooks/useServerActions";
import BondDetailsForm from "./components/BondDetailsForm";
import BondPreviewDetail from "./components/BondPreviewDetails";
import ComplianceChecks from "./components/ComplianceChecks";
import DocumentaryRequirements from "./components/DocumentaryRequirements";
import InvestmentDetails from "./components/InvestmentDetails";
import InvestorInformation from "./components/InvestorInformationForm";
import { getCurrencySymbol } from "../../../../components/facilities/TreasuryFacility";
import ChargeDetails from "./components/ChargeDetails";

const CreateBond = (props) => {
  const [current, setCurrent] = useState(0);
  const { userData } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const { mutate, loading, data: searchData } = useSearchCustomer(session);
  const customerID = Form.useWatch("customerID", form);
  const productID = Form.useWatch("productName", form);
  const investorAmount = Form.useWatch("investorAmount", form);
  const [formData, setFormData] = useState({
    investorInformation: null,
    bondDetails: null,
    investmentDetails: null,
    complianceChecks: null,
    documentRequirements: null,
  });

  const navigate = useNavigate();
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [bondDetails, setBondDetails] = useState([]);
  const [currency, setCurrency] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [investorTypeOptions, setInvestorTypeOptions] = useState([]);
  const [bondTypeOptions, setBondTypeOptions] = useState([]);
  const [custodianOptions, setCustodianOptions] = useState([]);
  const [issuerOptions, setIssuerOptions] = useState([]);
  const [couponFrequencyOptions, setCouponFrequencyOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [kycStatusOptions, setKycStatusOptions] = useState([]);
  const [amlScreeningOptions, setAmlScreeningOptions] = useState([]);
  const [sanctionScreeningOptions, setSanctionScreeningOptions] = useState([]);
  const [centralBankReportOptions, setCentralBankReportOptions] = useState([]);
  const [documentStatusOptions, setDocumentStatusOptions] = useState([]);
  const [entityId, setEntityId] = useState({});
  const [customerSelected, setCustomerSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isCreateButton, setIsCreateButton] = useState(true);
  const [contractRefId, setContractRefId] = useState(null);
  const [costPerUnit, setCostPerUnit] = useState(null);
  const [couponRate, setCouponRate] = useState(0);
  const [commission, setCommission] = useState(null);
  const [transferCharge, setTransferCharge] = useState(null);
  const [setupCharge, setSetupCharge] = useState(null);
  const [fixedCouponRate, setFixedCouponRate] = useState(null);
  const [chargeData, setChargeData] = useState(null);
  const [witholdingTax, setWitholdingTax] = useState(null);
  const [redemptionCharge, setRedemptionCharge] = useState(null);

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.BondContractTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;

        let tempInvestorTypeOptions = [];
        let tempCustodians = [];
        let tempKycStatusOptions = [];
        let tempAmlScreeningOptions = [];
        let tempSanctionScreeningOptions = [];
        let tempCentralBankReportOptions = [];
        let tempDocumentStatusOptions = [];

        const tempProductOptions = objList?.productOptions
          ?.filter(
            (element) => element.status?.text?.toLowerCase() === "active"
          )
          .map((element) => ({
            value: element.id,
            label: element.productName,
          }));

        objList?.custodians?.forEach((element) => {
          tempCustodians.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.investorTypeOptions?.forEach((element) => {
          tempInvestorTypeOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.kycStatusOptions?.forEach((element) => {
          tempKycStatusOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.amlScreeningOptions?.forEach((element) => {
          tempAmlScreeningOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.sanctionScreeningOptions?.forEach((element) => {
          tempSanctionScreeningOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.centralBankReportOptions?.forEach((element) => {
          tempCentralBankReportOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.documentStatusOptions?.forEach((element) => {
          tempDocumentStatusOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        setProductOptions(tempProductOptions);
        setCustodianOptions(tempCustodians);
        setInvestorTypeOptions(tempInvestorTypeOptions);
        setKycStatusOptions(tempKycStatusOptions);
        setAmlScreeningOptions(tempAmlScreeningOptions);
        setSanctionScreeningOptions(tempSanctionScreeningOptions);
        setCentralBankReportOptions(tempCentralBankReportOptions);
        setDocumentStatusOptions(tempDocumentStatusOptions);
        setIsLoading(false);

        form.setFieldsValue({
          branchCode: userData?.officeName,
          initiatedBy: userData?.username,
          userID: userData?.userId,
        });
      }
    });
  }

  function getBondTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.BondProductTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempBondTypeOptions = [];
        let tempIssuerOptions = [];
        let tempCouponFrequencyOptions = [];
        let tempCurrencyOptions = [];

        objList?.bondTypes?.forEach((element) => {
          tempBondTypeOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.issuerTypes?.forEach((element) => {
          tempIssuerOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponFrequencies?.forEach((element) => {
          tempCouponFrequencyOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.currencies?.forEach((element) => {
          tempCurrencyOptions.push({
            value: element.code,
            label: element.displayLabel,
            symbol: element.displaySymbol,
          });
        });

        setBondTypeOptions(tempBondTypeOptions);
        setIssuerOptions(tempIssuerOptions);
        setCouponFrequencyOptions(tempCouponFrequencyOptions);
        setCurrencyOptions(tempCurrencyOptions);
        setIsLoading(false);
      }
    });
  }

  const getBondById = (params) => {
    const url = `${apiConfig.GetBondProduct}/${params}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        form.setFieldsValue({
          key: objDetail?.id,
          initiationDate: dayjs(),
          issueDate: dayjs(),
          bondType: objDetail?.bondType?.value ?? null,
          issuer: objDetail?.bondIssuerName ?? "",
          currency: objDetail?.currencyCode ?? "",
          maturityDate:
            dayjs(BOM.FormatArrayDate(objDetail?.maturityDate)) ?? null,
          settlementDate:
            dayjs(BOM.FormatArrayDate(objDetail?.maturityDate)) ?? null,
          tenor: objDetail?.bondTenor ?? "",
          couponRate: objDetail?.fixedCouponRate ?? "",
          couponFrequency: objDetail?.bondCouponFrequency?.value ?? null,
          custodian: objDetail?.custodian?.id ?? null,
        });

        setChargeData({
          commission: objDetail?.commission,
          setupCharge: objDetail?.setupCharge,
          redemptionCharge: objDetail?.redemptionCharge,
          transferCharge: objDetail?.transferCharge,
          allowTax: objDetail?.allowTax,
          taxGroup: objDetail?.taxGroup,
          setupCharges: objDetail?.setupCharges,
          redemptionCharges: objDetail?.redemptionCharges,
          transferCharges: objDetail?.transferCharges,
          allowBrokerage: objDetail?.allowBrokerage,
        });

        setIsLoading(false);
        setCouponRate(objDetail?.fixedCouponRate);
        setCostPerUnit(objDetail?.faceValue);
        setCommission(objDetail?.commission);
        setSetupCharge(objDetail?.setupCharge);
        setRedemptionCharge(objDetail?.redemptionCharge);
        setTransferCharge(objDetail?.transferCharge);
        setWitholdingTax(objDetail?.withholdingTax);
        setCurrency(objDetail?.currencyCode);
        setFixedCouponRate(objDetail?.fixedCouponRate);
      }
    });
  };

  const getAccountOverviewList = (param) => {
    const url = `${apiConfig.Clients}/${param}/accounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempSavingsArray = [];
        let tempAccountOptions = [];

        objList?.savingsAccounts
          ?.filter(
            (item) =>
              item?.status?.active === true && item?.depositType?.id === 100
          )
          ?.forEach((element) => {
            tempSavingsArray.push({
              value: element?.id,
              label: `${element?.accountNo || "-"} - ${
                element?.productName || "-"
              }`,
              // Keep all original data
              ...element,
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo || "-",
              productName: element?.depositType.value || "-",
              status:
                element?.status.active === true
                  ? "Active"
                  : element?.status.active === false
                  ? "Closed"
                  : "-",
            });
          });

        tempSavingsArray?.forEach((element) => {
          tempAccountOptions.push({
            value: element.id,
            label: `${element.depositType.value} - ${element.accountNo}`,
          });
        });

        setAccountOptions(tempAccountOptions);
      }
    });
  };

  const getKycInfo = () => {
    const url = `${apiConfig.Clients}/template?staffInSelectedOfficeOnly=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;

        form.setFieldsValue({
          bvn: objList?.bvn ? objList?.bvn : "-",
          tin: objList?.tin ? objList?.taxJurisdiction : "-",
        });
      }
    });
  };

  useEffect(() => {
    getTemplate();
    getBondTemplate();
    getKycInfo();
  }, []);

  useEffect(() => {
    if (productID) {
      getBondById(productID);
    }
  }, [productID]);

  const updateFormData = (section, newData) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        ...newData,
      },
    }));
  };

  function onFinish(newData) {
    setFormData({
      ...formData,
      ...newData,
    });
    setCurrent(current + 1);
  }

  function next() {
    const stepsUsingForm = [0, 1, 3, 4, 5]; // indices of steps

    if (stepsUsingForm.includes(current)) {
      form.submit(); // only those steps trigger onFinish
    } else {
      setCurrent(current + 1);
    }
  }

  function prev() {
    const prevStep = current - 1;
    setCurrent(prevStep);
    setCompletedSteps((prev) => {
      const updated = prev.filter((stepIndex) => stepIndex < prevStep);
      return updated;
    });
  }

  const getCustomerDetailById = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${param}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        form.setFieldsValue({
          key: objDetail?.id,
          id: objDetail?.id,
          investorName: objDetail?.displayName ? objDetail?.displayName : "-",
          phoneNumber: objDetail?.mobileNo ? objDetail?.mobileNo : "-",
          email: objDetail?.emailAddress ? objDetail?.emailAddress : "-",
        });

        // setCurrentCustomerDetails(tempCurrentCustomer);
        setIsLoading(false);
      }
    });
  };

  const getAddresses = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Client}/${param}/addresses`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        const address = objDetail[0];

        form.setFieldsValue({
          key: address?.id,
          id: address?.id,
          address: address?.addressLine1 ? address?.addressLine1 : "-",
          city: address?.city,
        });
        setIsLoading(false);
      }
    });
  };

  const handleSearch = async (searchId) => {
    try {
      const res = await mutate(searchId);

      getCustomerDetailById(res.entityId);
      getAddresses(res.entityId);
      getAccountOverviewList(res.entityId);
      setEntityId(res.entityId);
      setCustomerSelected(true);
    } catch (error) {
      console.error("Error during search:", error);
    }
  };

  const handleSubmit = () => {
    let formValues = {
      ...formData.investmentDetails,
      ...formData.complianceChecks,
      ...formData.documentRequirements,
    };
    console.log(formData?.bondDetails);

    formValues.clientId = entityId;
    formValues.investerType =
      formData?.investorInformation?.investorType ?? formData?.investerType;
    formValues.productId =
      formData?.bondDetails?.productName ?? formData?.productName;
    formValues.bondType = formData?.bondDetails?.bondType ?? formData?.bondType;
    formValues.tenor = formData?.bondDetails?.tenor ?? formData?.tenor;
    formValues.issuer = formData?.bondDetails?.issuer ?? formData?.issuer;
    formValues.issueDate = BOM.DateTime(
      formData?.bondDetails?.issueDate ?? formData?.issueDate,
      "only-date"
    );
    formValues.dealInitiationDate = BOM.DateTime(
      formData?.bondDetails?.initiationDate ?? formData?.initiationDate,
      "only-date"
    );
    formValues.fixedCouponRate = fixedCouponRate;
    // formValues.paymentType = 1;

    formValues.amount = formValues?.investorAmount;
    formValues.numberOfUnits = 10000;
    formValues.settlementAccountId = formValues?.settlementAccountNumber;
    formValues.sanctionScreening = formValues?.sanctionsScreening;
    formValues.centralBankReport = formValues?.centralBankReportingRequirements;
    formValues.applicationFormStatus = formValues?.investorApplicationForm;
    formValues.bondPurchaseAgreement =
      formValues?.executedBondPurchaseAgreement;
    formValues.settlementDate = formValues.settlementDate
      ? BOM.DateTime(formValues.settlementDate, "only-date")
      : formValues.settlementDate;
    formValues.issuerRiskRating = 1;
    formValues.marketRiskConsideration = 1;
    formValues.concentrationRisk = 1;

    delete formValues.sanctionsScreening;
    delete formValues.centralBankReportingRequirements;
    delete formValues.investorApplicationForm;
    delete formValues.executedBondPurchaseAgreement;
    delete formValues.investorAmount; // remove after fix
    delete formValues.numberOfUnitsPurchased; // remove after fix
    delete formValues.settlementAccountNumber; // remove after fix

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.CreateBondContract, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        setSuccessModalVisible(true);
        setContractRefId(res.contractReferenceId);
        setIsLoading(false);
      }
    });
  };

  const handleInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleClose = () => {
    setSuccessModalVisible(false);
    setWarningModalVisible(false);
  };

  function onCancel() {
    navigate("/bond-contract", { replace: false });
  }

  useEffect(() => {
    const purchasePrice = Number(
      investorAmount - investorAmount * (couponRate / 100)
    );

    const numberOfUnits = Number(investorAmount / costPerUnit);

    form.setFieldsValue({
      purchasePrice: investorAmount ? Number(purchasePrice) : 0,
      numberOfUnitsPurchased: investorAmount ? Number(numberOfUnits) : 0,
    });
  }, [investorAmount, couponRate, costPerUnit, form]);

  useEffect(() => {
    const currentPurchasePrice = Number(
      investorAmount - investorAmount * (couponRate / 100)
    );

    if (isNaN(currentPurchasePrice)) {
      console.warn("Invalid purchase price:", investorAmount, couponRate);
      return;
    }

    const calculateCharge = (charge) => {
      if (!charge || charge.amount == null || !charge.chargeCalculationType)
        return 0;

      const type = charge.chargeCalculationType.value?.toLowerCase();
      const amount = Number(charge.amount);

      if (isNaN(amount)) return 0;

      if (type === "flat") {
        return amount;
      }

      if (type === "% amount") {
        return currentPurchasePrice * (amount / 100);
      }

      return 0;
    };

    let totalConsideration = currentPurchasePrice;

    totalConsideration += calculateCharge(setupCharge);
    totalConsideration += calculateCharge(transferCharge);
    totalConsideration += calculateCharge(commission);

    form.setFieldsValue({
      totalConsideration: totalConsideration ? Number(totalConsideration) : 0,
    });
  }, [
    form,
    commission,
    transferCharge,
    setupCharge,
    couponRate,
    investorAmount,
  ]);

  const currencySymbol = getCurrencySymbol(currency, currencyOptions);

  const stepsContent = [
    {
      title: "Investor Information",
      component: (
        <InvestorInformation
          handleSearch={handleSearch}
          searchData={searchData}
          formData={formData}
          form={form}
          customerID={customerID}
          updateFormData={(data) => updateFormData("investorInformation", data)}
          onFinish={onFinish}
          handleInputChange={handleInputChange}
          investorTypeOptions={investorTypeOptions}
          customerSelected={customerSelected}
        />
      ),
    },
    {
      title: "Bond Details",
      component: (
        <BondDetailsForm
          formData={formData}
          form={form}
          onFinish={onFinish}
          updateFormData={(data) => updateFormData("bondDetails", data)}
          handleInputChange={handleInputChange}
          productOptions={productOptions}
          bondTypeOptions={bondTypeOptions}
          issuerOptions={issuerOptions}
          currencyOptions={currencyOptions}
          custodianOptions={custodianOptions}
          couponFrequencyOptions={couponFrequencyOptions}
        />
      ),
    },
    {
      title: "Charge Details",
      component: (
        <ChargeDetails
          chargeData={chargeData}
          currencySymbol={currencySymbol}
        />
      ),
    },
    {
      title: "Investment Details",
      component: (
        <InvestmentDetails
          formData={formData}
          form={form}
          onFinish={onFinish}
          updateFormData={(data) => updateFormData("investmentDetails", data)}
          handleInputChange={handleInputChange}
          accountOptions={accountOptions}
          currencySymbol={currencySymbol}
        />
      ),
    },
    {
      title: "Compliance Checks",
      component: (
        <ComplianceChecks
          formData={formData}
          form={form}
          onFinish={onFinish}
          updateFormData={(data) => updateFormData("complianceChecks", data)}
          handleInputChange={handleInputChange}
          kycStatusOptions={kycStatusOptions}
          amlScreeningOptions={amlScreeningOptions}
          sanctionScreeningOptions={sanctionScreeningOptions}
          centralBankReportOptions={centralBankReportOptions}
        />
      ),
    },
    {
      title: "Document Requirements",
      component: (
        <DocumentaryRequirements
          formData={formData}
          form={form}
          onFinish={onFinish}
          updateFormData={(data) =>
            updateFormData("documentRequirements", data)
          }
          documentStatusOptions={documentStatusOptions}
          userData={userData}
          entityId={entityId}
        />
      ),
    },
    {
      title: "Preview",
      component: (
        <BondPreviewDetail
          formData={formData}
          investorTypeOptions={investorTypeOptions}
          productOptions={productOptions}
          bondTypeOptions={bondTypeOptions}
          issuerOptions={issuerOptions}
          couponFrequencyOptions={couponFrequencyOptions}
          accountOptions={accountOptions}
          kycStatusOptions={kycStatusOptions}
          amlScreeningOptions={amlScreeningOptions}
          sanctionScreeningOptions={sanctionScreeningOptions}
          centralBankReportOptions={centralBankReportOptions}
          documentStatusOptions={documentStatusOptions}
          custodianOptions={custodianOptions}
          chargeData={chargeData}
          currencySymbol={currencySymbol}
        />
      ),
    },
  ];

  const handleGoBack = () => {
    // navigate("/contract-booking-interbankplacement");
    navigate("/bond-contract", { replace: false });
  };

  return (
    <MainLayout
      pageItems={staticConfig.newContractBookingBond}
      onSave={handleSubmit}
    >
      <TopContent
        pageTitle={labelConfig.manageContractBookingBond}
        createPageTitle={labelConfig.createContractBookingBond}
      />

      <Spin spinning={loading || isLoading} size="large">
        <div
          className="contract-form-container"
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            height: "720px",
            widtth: "100%",
          }}
        >
          {/* Left side - Vertical steps */}
          <StepsComponent
            steps={stepsContent}
            current={current}
            completedSteps={completedSteps}
          />

          <StepsCard
            current={current}
            onNext={next}
            onPrev={prev}
            totalSteps={7}
            submitLabel={"Create Contract"}
            nextLabel={`Next - ${stepsContent[current + 1]?.title || ""}`}
            onSubmit={handleSubmit}
            onGoBack={onCancel}
          >
            {stepsContent[current].component}
          </StepsCard>

          {/* Success Modal */}
          {/* <FeedbackModal
            visible={successModalVisible}
            type="success"
            onPrimaryAction={onCancel}
            onClose={handleClose}
            message="Bond Contract has been successfully created."
            primaryButtonText="Close"
          /> */}

          <SuccessModal
            visible={successModalVisible}
            onClose={handleGoBack}
            isCreateButton={isCreateButton}
            contractRef={contractRefId}
            successMessage={"Your Bond Contract has been created successfully."}
          />

          {/* Warning Modal */}
          <FeedbackModal
            visible={warningModalVisible}
            type="warning"
            onPrimaryAction={() => {
              onCancel();
            }}
            onSecondaryAction={() => {
              handleClose();
            }}
            onClose={handleClose}
          />
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CreateBond);
